<template>
    <v-container class="ma-0 pa-0 steps_container" fill-height>
        <v-row dense class="ma-0 pa-0">
			<v-col cols="12" align-self="start" class="ma-0 pa-0">
                <v-nav-guide
                    title="1"
                />
			</v-col>
		</v-row>

        <v-row dense class="ma-0 pa-0">
			<v-col cols="12" align-self="start" class="ma-0 pa-0">
                <v-img :src="require('@/assets/images/renew/img-illust-workout.svg')" />
			</v-col>
		</v-row>

        <v-row dense class="my-0 px-0 mx-7 pt-7 pb-5 div_divider">
			<v-col cols="12" align-self="start" class="ma-0 pa-0">
                <p style="font-size:14px; font-weight:bolder; color:#3686d7; letter-spacing:-0.6px;">운동 가이드</p>
                <p style="font-size:24px; font-weight:bolder; color:#193263; letter-spacing:-1px;" v-html="getTitle"/>
			</v-col>
            <v-col cols="12" align-self="start" class="ma-0 pa-0">
                <p style="font-size:14px; line-height:24px; font-weight:bolder; color:#7584a1; letter-spacing:-0.6px;">{{getDescription}}</p>
            </v-col>
		</v-row>

        <v-row dense class="my-0 mx-7 pt-7 div_divider">
            <v-col cols="12" align-self="start" align="center">
                <v-cardio-card :isInsufficientExercise="isInsufficientExercise" />
            </v-col>
        </v-row>

        <v-row dense class="ma-0 pb-5 px-7 pt-7">
            <v-col cols="12" align-self="start" align="left">
                <p class="weight-title">
                    {{ getWeightTitle }}
                </p>
                <p class="weight-desc">
                    {{ getWeightDescription }}
                </p>
            </v-col>
            <v-col cols="12" class="ma-0 pa-0" align-self="start" style="border: 1px solid #eeeeee;">
                <template v-for="id in 3">
                    <v-weight-card
                        class="mb-6"
                        :isInsufficientExercise="isInsufficientExercise"
                        :id="id"
                        :key="id"
                    />
                </template>
            </v-col>
        </v-row>

        <v-row dense class="ma-0 pa-7 footer">
			<v-col cols="12" align-self="start" class="ma-0 pa-0">
                <p class="footer-bolder" v-html="$t('disease.footer-origin')"/>
                <ul class="footer-origin">
                    <li>{{$t('exerciseGuide.desc')}}</li>
                    <li>{{$t('exerciseGuide.desc2')}}</li>
                </ul>
			</v-col>
		</v-row>

    </v-container>
</template>
<script>
    import { mapState, mapGetters } from 'vuex'
    import types from '../../store/types'
    import VNavGuide from "@/components/navGuide"
    import VCardioCard from "@/components/cardioCard"
    import VWeightCard from "@/components/weightCard"

    export default {
        components: {
            VNavGuide,
            VCardioCard,
            VWeightCard
        },
        data() {
            return {
            }
        },
        computed: {
            ...mapGetters({
                surveyExercise : types.addItem.getters.section4,
            }),
            ...mapGetters('survey', [
                'checkupResult',
                'checkUp'
            ]),
            diseaseList() {
                const diseaseList = [
                    {
                        name: '당뇨병',
                        index: this.checkupResult.dmIndex
                    },
                    {
                        name: '간암',
                        index: this.checkupResult.liverIndex
                    },
                    {
                        name: '대장암',
                        index: this.checkupResult.colorectalIndex
                    },
                    {
                        name: '위암',
                        index: this.checkupResult.stomachIndex
                    },
                    {
                        name: '폐암',
                        index: this.checkupResult.lungIndex
                    },
                    {
                        name: '전립선암',
                        index: this.checkupResult.prostateIndex
                    },
                    {
                        name: '유방암',
                        index: this.checkupResult.breastIndex
                    },
                ]
                return diseaseList
            },
            isInsufficientExercise() {
                // 운동량 문진에서 고강도 운동 0일 & 중강도 운동 0~1일 & 가벼운 운동 0~7일 선택 시
                const { wlk30WekFreq, mov20WekFreq, mov30WekFreq  } = this.checkUp
                //      걷기,         중강도,        고강도
                if ( mov30WekFreq <= 0 && (mov20WekFreq >= 0 && mov20WekFreq <= 1) && (wlk30WekFreq >= 0 && wlk30WekFreq <= 7)) {
                    return true
                }

                return false
            },
            getDate() {
                return this.checkupResult.displayCheckupDate
            },
            getTitle() {
                if(this.isInsufficientExercise) {
                    return this.$t('exerciseGuide.low.title')
                }
                return this.$t('exerciseGuide.high.title')
            },
            getDescription() {
                if(this.isInsufficientExercise) {
                    return this.$t('exerciseGuide.low.desc')
                }
                return this.$t('exerciseGuide.high.desc')
            },
            getWeightTitle() {
                if(this.isInsufficientExercise) {
                    return this.$t('exerciseGuide.low.weight.title')
                }
                return this.$t('exerciseGuide.high.weight.title')
            },
            getWeightDescription() {
                if(this.isInsufficientExercise) {
                    return this.$t('exerciseGuide.low.weight.desc')
                }
                return this.$t('exerciseGuide.high.weight.desc')
            }
        },
        methods: {
        },
        mounted() {
            window.scrollTo(0, 0)
        }
    }
</script>
<style scoped>
    .main-container {
        font-family:  "NanumSquare", sans-serif;;
        padding: 0px 30px;
    }
    .main-img {
        position: absolute;
        top: 95px;
        background: center / cover no-repeat url('../../assets/images/img-illust-exercise.png');
        width: 100vw;
        max-width: 500px;
        height: 390px;
        z-index: -1;
    }
    .main-title {
        margin-top: 64px;
        font-family: NanumSquare, sans-serif;
        font-weight: 800;
        font-size: 26px;
        text-align: center;
        margin-bottom: 13px;
    }
    .main-desc {
        font-family: "NanumSquare", sans-serif;
        font-weight: bolder;

        font-size: 16px;
        line-height: 160%;
        color: black;
        opacity: 0.5;
        margin-bottom: 40px;
    }
    .seperator {
        height: 1px;
        width: 100%;
        background-color: black;
        margin-bottom: 40px;
        opacity: 0.1;
    }
    .weight-title {
        font-family: "NanumSquare", sans-serif;
        font-weight: bolder;
        font-size:18px;
        letter-spacing: -0.86px;
        color: #193263;
    }
    .weight-desc {
        font-family: "NanumSquare", sans-serif;
        font-size:14px;
        letter-spacing: -0.6px;
        color: #475b82;
    }
    .footer {
        background-color: #f3f5f7;
        font-family: "NanumSquare", sans-serif;
        font-size: 12px;
        color: #193263;
        line-height: 20px;
        letter-spacing: -0.51px;
        font-weight: bolder;
        word-break: keep-all;
    }
    .footer-bolder{
        font-weight: bolder;
    }

    .footer-origin {
        font-size: 12px;
        color: #193263;
        line-height: 20px;
        letter-spacing: -0.51px;
        
        word-break: keep-all;
    }
    .div_divider {
        border-bottom: 1px solid #e2e6ea;
    }

    ul, ol, li {
        list-style: disc;
    }

</style>
